module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_location_photowedding@3x-a1124010ab508abbd49fc0ae03d1bfca.webp";